import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "withdraw-password-page" }
const _hoisted_2 = { class: "success_container" }
const _hoisted_3 = { class: "success_title" }
const _hoisted_4 = { class: "success_desc" }
const _hoisted_5 = { class: "btn_group" }

import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'

import CustomHeader from '../components/common/customHeader.vue'
import MainButton from '../../themeThree/components/common/mainButton.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'withdrawPWCompletion',
  setup(__props) {

const router = useRouter()
const userStore = useUserStore()


const backNavigate = () => {
  userStore.setRechargeBonusType(0)
  userStore.setTakeFirstDeposit(false)
  router.go(-1)
}

const goToFund = () => {
  router.replace({ path: '/fundsHistory', query: { tabIndex: 0 } })
}
const goHome = () => {
  router.replace({ path: '/' })
}

const goWithdraw = () => {
  router.replace({ path: '/sd-withdraw' })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('withdrawPasswordSuccess.title'),
      "is-popup-close-back-icon": false,
      onClosePopup: backNavigate,
      "show-fund": false,
      onGoToFund: goToFund
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "icon_wrapper" }, [
        _createElementVNode("div", { class: "success_icon" }, "✔")
      ], -1)),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('withdrawPasswordSuccess.successTitle')), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('withdrawPasswordSuccess.successDesc')), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "btn primary",
          onClick: goHome
        }, _toDisplayString(_ctx.$t('withdrawPasswordSuccess.backHome')), 1),
        _createElementVNode("div", {
          class: "btn secondary",
          onClick: goWithdraw
        }, _toDisplayString(_ctx.$t('withdrawPasswordSuccess.continueWithdraw')), 1)
      ])
    ])
  ]))
}
}

})